<template>
  <v-card flat tile class="plano-workspace grey lighten-4 fill-height d-flex flex-column">
    <!-- ESTADO VACÍO -->
  
    <v-container
      v-if="!hayPlanoSeleccionado"
      class="fill-height d-flex flex-column justify-center align-center"
    >
      <v-icon size="120" color="grey lighten-2">mdi-map-marker-radius-outline</v-icon>
      <div class="text-h5 grey--text text--darken-1 font-weight-light mt-4">
        Selecciona un plano para comenzar
      </div>
      <div class="text-body-2 grey--text mt-2">
        Utiliza el panel de la izquierda para explorar los planos disponibles.
      </div>
    </v-container>

    <template v-else>

      <!-- HUD -->
      <v-sheet
        v-if="!soloPlanos"
        class="action-hud pa-2 d-flex align-center elevation-3 rounded-pill ma-4 px-4"
        :class="$vuetify.breakpoint.xs ? 'rounded-lg my-2' : 'rounded-pill my-4'"
        :style="{ width: $vuetify.breakpoint.xs ? '95%' : 'auto' }"
      >
        <div class="d-flex align-center mr-4">
          <v-icon left color="primary">mdi-image-filter-center-focus</v-icon>
          <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">
            {{ selectedPlano.nombre || "Visualizador" }}
          </span>
        </div>

        <v-divider vertical class="mx-3"></v-divider>

        <v-btn
          v-if="modo === 1"
          @click="abrirDialogoSeleccionArmario"
          color="primary"
          rounded
          depressed
          small
          class="mr-2 px-4"
        >
          <v-icon left small>mdi-plus-box</v-icon>
          {{ $vuetify.breakpoint.xs ? "" : "Generar Región" }}
        </v-btn>

        <v-btn
          v-if="modo === 1"
          @click="modo = 2"
          color="warning"
          outlined
          rounded
          small
          class="px-4"
        >
          <v-icon left small>mdi-pencil</v-icon>
          {{ $vuetify.breakpoint.xs ? "" : "Editar regiones" }}
        </v-btn>

        <v-btn
          v-if="modo === 2"
          @click="finalizarEdicion"
          color="success"
          depressed
          rounded
          small
          class="px-4"
        >
          <v-icon left small>mdi-check-circle</v-icon>
          Finalizar edición
        </v-btn>

        <v-spacer></v-spacer>

        <v-chip
          v-if="modo === 2"
          color="orange lighten-4"
          orange--text
          small
          label
          class="font-weight-bold"
        >
          MODO EDICIÓN ACTIVO
        </v-chip>
      </v-sheet>
      <!-- CONTENEDOR -->
      <div class="plano-viewport flex-grow-1">

        <div
          v-if="imagenParaMostrar"
          ref="planoContainer"
          class="plano-canvas elevation-5"
          :style="{
            backgroundImage: `url(${imagenParaMostrar})`,
            backgroundSize: backgroundSize,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: backgroundPosition,
          }"
          @click="onCanvasClick"
        >
  
          <div
            v-for="region in regiones"
            :key="`armario-${region.id}`"
            :ref="`region-${getRegionKey(region)}`"
            class="region-box"
            :class="{
              'region-view': modo === 1,
              'region-edit': modo === 2,
              'region-highlight': hayRegionSeleccionada && region.id === regionSeleccionadaId,
              'region-armario': region.tipo_region === 'armario',
              'region-pulse': hayRegionSeleccionada && region.id === regionSeleccionadaId,
              'region-selected': regionEditando && getRegionKey(region) === getRegionKey(regionEditando),
            }"
            :style="getRegionBoxStyle(region)"
            @click.stop="onRegionClick(region)"
          >
            <v-tooltip bottom open-delay="200" :disabled="modo === 2 || $vuetify.breakpoint.xs">
            <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="region-visual" :style="getRegionVisualStyle(region)">
              <div v-if="modo === 2" class="region-label">Mover/Redimensionar</div>

              <v-btn
                v-if="modo === 2"
                icon
                x-small
                color="white"
                class="delete-region-btn"
                @click.stop="eliminarRegion(region)"
              >
                <v-icon small color="error">mdi-close-circle</v-icon>
              </v-btn>
            </div>
            </template>
            <span>{{ region.name || region.nombre || 'Sin nombre' }}</span>
            </v-tooltip>
          </div>
          <div
            v-for="region in regionesPlano"
            :key="`plano-${region.id}`"
            :ref="`region-${getRegionKey(region)}`"
            class="region-box"
            :class="{
              'region-view': modo === 1,
              'region-edit': modo === 2,
              'region-highlight': hayRegionSeleccionada && region.id === regionSeleccionadaId,
              'region-plano': region.tipo_region === 'plano',
              'region-pulse': hayRegionSeleccionada && region.id === regionSeleccionadaId,
              'region-selected': regionEditando && getRegionKey(region) === getRegionKey(regionEditando),
            }"
            :style="getRegionBoxStyle(region)"
            @click.stop="onRegionClick(region)"
          >
          <v-tooltip bottom open-delay="200" :disabled="modo === 2 || $vuetify.breakpoint.xs">
            <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="region-visual" :style="getRegionVisualStyle(region)">
              <div v-if="modo === 2" class="region-label">Mover/Redimensionar</div>

              <v-btn
                v-if="modo === 2"
                icon
                x-small
                color="white"
                class="delete-region-btn"
                @click.stop="eliminarRegion(region)"
              >
                <v-icon small color="error">mdi-close-circle</v-icon>
              </v-btn>
            </div>
            </template>
            <span>{{ region.name || region.nombre || 'Sin nombre' }}</span>
          </v-tooltip>
          </div>

          <Moveable
            ref="moveable"
            v-if="modo === 2 && moveableTarget"
            :target="moveableTarget"
            :draggable="true"
            :resizable="true"
            :rotatable="true"
            :origin="false"
            :throttle-drag="0"
            :throttle-resize="0"
            :throttle-rotate="0"
            @dragStart="onMoveableDragStart"
            @drag="onMoveableDrag"
            @dragEnd="onMoveableDragEnd"
            @resizeStart="onMoveableResizeStart"
            @resize="onMoveableResize"
            @resizeEnd="onMoveableResizeEnd"
            @rotateStart="onRotateStart"
            @rotate="onRotate"
            @rotateEnd="onRotateEnd"
          />
        </div>
      </div>
      

      
    </template>

    <!-- DIÁLOGO: Seleccionar destino -->
    <v-dialog v-model="dialogSeleccionarArmario" max-width="560px" scrollable>
      <v-card rounded="xl">
        <v-card-title class="primary white--text">
          <v-icon left color="white">
            {{ tabDestinoRegion === 0 ? "mdi-dresser" : "mdi-floor-plan" }}
          </v-icon>
          {{ tabDestinoRegion === 0 ? "Vincular Armario" : "Vincular Subplano" }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogSeleccionarArmario = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs v-model="tabDestinoRegion" grow background-color="grey lighten-4">
          <v-tab>
            <v-icon left small>mdi-dresser</v-icon>
            Armarios
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-floor-plan</v-icon>
            Planos
          </v-tab>
        </v-tabs>

        <v-toolbar flat dense color="grey lighten-4">
          <span class="text-caption grey--text font-weight-bold">
            {{ tabDestinoRegion === 0 ? "SELECCIONA O CREA UN ELEMENTO" : "SELECCIONA UN SUBPLANO" }}
          </span>
          <v-spacer></v-spacer>

          <v-btn
            v-if="tabDestinoRegion === 0"
            small
            color="primary"
            text
            @click="iniciarCreacionArmarioRaiz"
          >
            <v-icon left small>mdi-plus</v-icon>
            Nuevo Raíz
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0">
          <!-- TAB ARMARIOS -->
          <div v-show="tabDestinoRegion === 0">
            <v-expand-transition>
              <div v-show="creandoArmarioRaiz" class="pa-4 blue lighten-5">
                <v-text-field
                  v-model="nuevoArmario"
                  label="Nombre del nuevo armario"
                  outlined
                  dense
                  hide-details
                  bg-color="white"
                  class="mb-2"
                ></v-text-field>
                <div class="d-flex justify-end">
                  <v-btn x-small text @click="creandoArmarioRaiz = false" class="mr-2">
                    Cancelar
                  </v-btn>
                  <v-btn x-small color="primary" @click="crearArmarioRaiz">
                    Guardar elemento
                  </v-btn>
                </div>
              </div>
            </v-expand-transition>

            <v-list v-if="armariosAplanados.length > 0" class="py-0">
              <v-list-item
                v-for="armario in armariosAplanados"
                :key="armario.id"
                @click="seleccionarArmarioParaRegion(armario)"
                class="border-bottom"
              >
                <v-list-item-content :style="{ paddingLeft: armario.nivel * 20 + 'px' }">
                  <v-list-item-title class="d-flex align-center">
                    <div class="hierarchy-line" v-if="armario.nivel > 0"></div>
                    <v-icon
                      small
                      class="mr-2"
                      :color="armario.children_count > 0 ? 'orange' : 'grey'"
                    >
                      {{ armario.children_count > 0 ? "mdi-folder" : "mdi-circle-medium" }}
                    </v-icon>
                    <span :class="armario.nivel === 0 ? 'font-weight-bold' : ''">
                      {{ armario.name }}
                    </span>
                    <v-chip
                      v-if="armario.adjuntos_count > 0"
                      x-small
                      class="ml-2"
                      color="blue lighten-4"
                      blue--text
                    >
                      {{ armario.adjuntos_count }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    @click.stop="abrirDialogCrearSubNodo(armario)"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <div v-else class="pa-8 text-center grey--text">
              No hay elementos disponibles.
            </div>
          </div>

          <!-- TAB PLANOS -->
          <div v-show="tabDestinoRegion === 1">
            <v-list v-if="planosDisponiblesParaRegion.length > 0" class="py-0">
              <v-list-item
                v-for="plano in planosDisponiblesParaRegion"
                :key="plano.id"
                @click="seleccionarPlanoParaRegion(plano)"
                class="border-bottom"
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center">
                    <v-icon small class="mr-2" color="primary">mdi-floor-plan</v-icon>
                    <span class="font-weight-medium">{{ plano.nombre }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="plano.descripcion">
                    {{ plano.descripcion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <div v-else class="pa-8 text-center grey--text">
              No hay subplanos disponibles.
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogos hijos -->
    <DialogCrearSubnodo
      :dialog.sync="dialogCrearSubNodo"
      :tiposNodo="tiposNodo"
      :bannerTipoSeleccionado="bannerTipoSeleccionado"
      @save-subnode="crearSubnodo"
    />

    <AdjuntosLista
      v-if="clickedRegion"
      :dialog="dialogAdjuntos"
      @close="closeAdjuntos"
      @add-adjunto="$emit('add-adjunto', $event)"
      @ver-en-plano="onVerEnPlano"
      @ver-en-arbol="onVerEnArbol"
      :adjuntos="adjuntos"
      :region="clickedRegion"
    />

    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top
      centered
      rounded="pill"
      color="grey darken-3"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
// import VueDraggableResizable from "vue-draggable-resizable";
// import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { jwtDecode } from "jwt-decode";
import DialogCrearSubnodo from "./dialogs/DialogCrearSubnodo.vue";
import AdjuntosLista from "../utils/AdjuntosLista.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Moveable from "vue-moveable"

export default {
  components: {
    DialogCrearSubnodo,
    AdjuntosLista,
    Moveable,
  },
  props: {
    nodo: Object,
    selectedPlano: { type: Object, default: null },
    armarios: { type: Array, default: () => [] },
    soloPlanos: { type: Boolean, default: false },
    planos: { type: Array, default: () => [] },
  },
  data() {
    return {
      ro: null,
      regiones: [],
      regionesPlano: [],
      clickedRegion: null,
      dialogAdjuntos: false,
      modo: 1, // 1 = visualización, 2 = edición
      modoCrear: false,
      containerReady: false,

      imagenAncho: 0,
      imagenAlto: 0,
      anchoImagen: 0,
      altoImagen: 0,

      offsetX: 0,
      offsetY: 0,
      backgroundSize: "contain",
      backgroundPosition: "center center",
      regionEditando: null,
      moveableTarget: null,
      estaRotando: false,
      moveableDragging: false,
      moveableFrame: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        rotate: 0,
      },
      moveableStartFrame: null,

      snackbar: false,
      snackbarText: "",

      idCliente: null,
      baseUrl: `/api/nodejs`,

      tabDestinoRegion: 0,
      armarioSeleccionadoParaRegion: null,
      planoSeleccionadoParaRegion: null,
      dialogSeleccionarArmario: false,
      armariosAplanados: [],
      tiposNodo: [],
      dialogCrearSubNodo: false,
      subnodoForm: {
        parent_id: null,
        name: "",
        tipo: "",
      },
      nuevoArmario: "",
      creandoArmarioRaiz: false,
      adjuntos: [],
    };
  },
  computed: {
    ...mapState(["usuarios"]),
    ...mapState("armarios", ["regionSeleccionada", "regionNueva"]),
     regionSeleccionadaId() {
      // si es objeto -> intenta id / id_armario; si es número/string -> úsalo tal cual
      if (!this.regionSeleccionada) return null;
      if (typeof this.regionSeleccionada === "object") {
        return this.regionSeleccionada.id ?? this.regionSeleccionada.id_armario ?? null;
      }
      return this.regionSeleccionada;
    },

    hayRegionSeleccionada() {
      return this.regionSeleccionadaId !== null && this.regionSeleccionadaId !== undefined;
    },
    bannerTipoSeleccionado() {
      const tipo = this.tiposNodo.find((t) => t.id === this.nuevoTipoSeleccionado);
      if (tipo && tipo.banner_url) {
        return `/api/nodejs${tipo.banner_url}`;
      }
      return null;
    },
    hayPlanoSeleccionado() {
      return (this.selectedPlano && Object.keys(this.selectedPlano).length > 0);
    },
    imagenParaMostrar() {
      if (this.selectedPlano?.ruta_archivo) {
        const ruta = this.selectedPlano.ruta_archivo.startsWith("/")
          ? this.selectedPlano.ruta_archivo
          : "/" + this.selectedPlano.ruta_archivo;
        return this.baseUrl + ruta;
      }
      return null;
    },
    planosDisponiblesParaRegion() {
      return (this.planos || []).filter(
        (plano) => String(plano.id) !== String(this.selectedPlano?.id)
      );
    },
  },
  watch: {
    // selectedPlano: {
    //   immediate: true,
    //   async handler(newPlano) {
    //     if (newPlano && newPlano.id) {
    //       await this.cargarRegionesDesdeAPI();

    //       // Muy importante: una vez cargadas regiones + DOM, recalcula offsets
    //       this.$nextTick(() => this.calcularOffsets());
    //     } else {
    //       this.regiones = [];
    //     }
    //   },
    // },
    selectedPlano: {
      immediate: true,
      async handler(newPlano) {
        if (newPlano && newPlano.id) {
          await this.cargarRegionesDesdeAPI();
          
          // FORZAR LLAMADA AQUÍ:
          if (this.imagenParaMostrar) {
            this.cargarImagenDimensiones(this.imagenParaMostrar);
          }

          this.$nextTick(() => this.calcularOffsets());
        } else {
          this.regiones = [];
          this.regionesPlano = [];
        }
      },
    },
    armarios: {
      immediate: true,
      handler(nuevosArmarios) {
        this.armariosAplanados = Array.isArray(nuevosArmarios)
          ? this.aplanarArmarios(nuevosArmarios)
          : [];
      },
    },
    imagenParaMostrar(newVal) {
      if (newVal) {
        this.cargarImagenDimensiones(newVal);
      } else {
        this.imagenAncho = 0;
        this.imagenAlto = 0;
        this.containerReady = false;
      }
    },
  },
  async mounted() {
    this.idCliente = localStorage.getItem("clienteSeleccionado")
      ? localStorage.getItem("clienteSeleccionado")
      : jwtDecode(localStorage.getItem("token"))?.id_cliente || 1;

    window.addEventListener("resize", this.calcularOffsets);
    await this.fetchTiposNodo();

    this.$nextTick(() => {
      const el = this.$refs.planoContainer;
      if (!el) return;

      this.ro = new ResizeObserver(() => {
        if (this.imagenParaMostrar && this.imagenAncho && this.imagenAlto) {
          this.calcularOffsets();
        }
      });
      this.ro.observe(el);
    });

    if(this.regionNueva) {
      this.seleccionarArmarioParaRegion(this.regionNueva);
    }

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcularOffsets);
    if (this.ro) this.ro.disconnect();
  },
  methods: {
    ...mapActions("armarios",["setRegionNueva"]),
    onVerEnArbol(region) {
      this.closeAdjuntos();
      this.$emit("ver-en-arbol", {
        ...region,
        id: region.id_armario || region.id,
      });
    },
    onVerEnPlano(region) {
      this.closeAdjuntos();

      const payload = {
        ...region,
        id: region.id_armario || region.id,
      };

      this.$emit("ver-en-plano", payload);
    },
    fetchTiposNodo() {
      return axios
        .get(`/api/nodejs/armarios/tipos`)
        .then((response) => {
          this.tiposNodo = response.data.tipos_armarios || [];
        })
        .catch((error) => {
          console.error("Error al cargar tipos de nodo:", error);
        });
    },

    // ---- CARGA DE REGIONES (FIX PRINCIPAL: normalizar strings -> number) ----
    async cargarRegionesDesdeAPI() {
      try {
        const response = await axios.get(
          `/api/nodejs/armarios/plano/${this.selectedPlano.id}`
        );

        const responseRegionPlanos = await axios.get(
          `/api/nodejs/planos/plano/${this.selectedPlano.id}`
        );

        this.regiones = (response.data || []).map((r) =>
          this.normalizarRegion({ ...r, tipo_region: "armario" })
        );

        this.regionesPlano = (responseRegionPlanos.data || []).map((r) =>
          this.normalizarRegion({ ...r, tipo_region: "plano" })
        );


        this.$nextTick(() => this.calcularOffsets());
      } catch (error) {
        console.error("Error al cargar regiones:", error);
        this.regiones = [];
        this.regionesPlano = [];
        this.snackbarText = "Error al cargar regiones";
        this.snackbar = true;
      }
    },

    // ---- ARMARIOS ----
    aplanarArmarios(armarios, nivel = 0) {
      let resultado = [];
      for (const armario of armarios) {
        const children_count = armario.children?.length || 0;

        resultado.push({
          ...armario,
          nivel,
          children_count,
        });

        if (armario.children && armario.children.length > 0) {
          resultado = resultado.concat(this.aplanarArmarios(armario.children, nivel + 1));
        }
      }
      return resultado;
    },

    abrirDialogCrearSubNodo(armario) {
      this.subnodoForm = {
        parent_id: armario.id,
        name: "",
        tipo: this.tiposNodo[0]?.value || "",
      };
      this.dialogSeleccionarArmario = false;
      this.$nextTick(() => {
        this.dialogCrearSubNodo = true;
      });
    },

    abrirDialogoSeleccionArmario() {
      this.tabDestinoRegion = 0;
      this.creandoArmarioRaiz = false;
      this.dialogSeleccionarArmario = true;
    },

    seleccionarArmarioParaRegion(armario) {
      this.armarioSeleccionadoParaRegion = armario;
      this.planoSeleccionadoParaRegion = null;
      this.modoCrear = true;
      this.dialogSeleccionarArmario = false;
      this.snackbarText = `Armario "${armario.name}" seleccionado. Haz clic en el plano para crear la región.`;
      this.snackbar = true;
    },

    onRotateStart() {
      this.estaRotando = true;
      if (!this.regionEditando) return;
      this.moveableStartFrame = { ...this.moveableFrame };
    },
    async onRotateEnd() {
      this.estaRotando = false;
      if (!this.regionEditando) return;
      await this.commitMoveableChanges();
    },
    onRotate(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      this.moveableFrame.rotate = Number(e.beforeRotate || 0);
      this.applyMoveableFrameToTarget();
    },
    async commitMoveableChanges() {
      if (!this.regionEditando || !this.moveableTarget) return;

      const lista =
        this.regionEditando.tipo_region === "plano" ? this.regionesPlano : this.regiones;

      const index = lista.findIndex((r) => r.id === this.regionEditando.id);
      if (index === -1) return;

      let leftPx = parseFloat(this.moveableTarget.style.left);
      let topPx = parseFloat(this.moveableTarget.style.top);
      let widthPx = parseFloat(this.moveableTarget.style.width);
      let heightPx = parseFloat(this.moveableTarget.style.height);

      if (!Number.isFinite(leftPx) || !Number.isFinite(topPx) ||
          !Number.isFinite(widthPx) || !Number.isFinite(heightPx)) {
        const fallback = this.getRegionPxBox(lista[index]);
        leftPx = Number.isFinite(leftPx) ? leftPx : fallback.left;
        topPx = Number.isFinite(topPx) ? topPx : fallback.top;
        widthPx = Number.isFinite(widthPx) ? widthPx : fallback.width;
        heightPx = Number.isFinite(heightPx) ? heightPx : fallback.height;
      }

      leftPx = Math.max(
        this.offsetX,
        Math.min(this.offsetX + this.anchoImagen - widthPx, leftPx)
      );

      topPx = Math.max(
        this.offsetY,
        Math.min(this.offsetY + this.altoImagen - heightPx, topPx)
      );

      const rotate =
        Number.isFinite(Number(this.moveableFrame.rotate))
          ? Number(this.moveableFrame.rotate)
          : this.extractRotationFromTransform(this.moveableTarget.style.transform);

      const regionActualizada = {
        ...lista[index],
        x: ((leftPx - this.offsetX) / this.anchoImagen) * 100,
        y: ((topPx - this.offsetY) / this.altoImagen) * 100,
        w: (widthPx / this.anchoImagen) * 100,
        h: (heightPx / this.altoImagen) * 100,
        rotation: rotate,
      };

      this.$set(lista, index, regionActualizada);
      this.regionEditando = regionActualizada;
      this.moveableFrame = {
        left: leftPx,
        top: topPx,
        width: widthPx,
        height: heightPx,
        rotate,
      };
      this.moveableStartFrame = null;

      await this.guardarRegion(regionActualizada);
    },
    onCanvasClick(event) {
      if (this.modoCrear) {
        this.agregarRegion(event);
        return;
      }

      if (this.modo === 2) {
        this.regionEditando = null;
        this.moveableTarget = null;
        this.moveableDragging = false;
        this.moveableStartFrame = null;
        this.moveableFrame = {
          left: 0,
          top: 0,
          width: 0,
          height: 0,
          rotate: 0,
        };
      }
    },
    // getRegionTransformStyle(region) {
    //   return {
    //     transform: `rotate(${Number(region.rotation || 0)}deg)`,
    //     transformOrigin: "center center",
    //   };
    // },
    getRegionPxBox(region) {
      return {
        left: this.pxFromPct(region.x, "w") + this.offsetX,
        top: this.pxFromPct(region.y, "h") + this.offsetY,
        width: this.pxFromPct(region.w, "w"),
        height: this.pxFromPct(region.h, "h"),
        rotate: Number(region.rotation || 0),
      };
    },

    applyMoveableFrameToTarget() {
      if (!this.moveableTarget) return;

      const { left, top, width, height, rotate } = this.moveableFrame;

      this.moveableTarget.style.left = `${left}px`;
      this.moveableTarget.style.top = `${top}px`;
      this.moveableTarget.style.width = `${width}px`;
      this.moveableTarget.style.height = `${height}px`;
      this.moveableTarget.style.transform = `rotate(${rotate}deg)`;
      this.moveableTarget.style.transformOrigin = "50% 50%";
    },

    extractRotationFromTransform(transform) {
      if (!transform || transform === "none") return 0;
      const match = transform.match(/rotate\((-?\d+(\.\d+)?)deg\)/);
      return match ? parseFloat(match[1]) : 0;
    },
    getRegionVisualStyle() {
      return {
        width: "100%",
        height: "100%",
        borderRadius: "4px",
      };
    },
    esRegionSeleccionada(region) {
      return (
        this.regionEditando &&
        this.getRegionKey(region) === this.getRegionKey(this.regionEditando)
      );
    },
    onMoveableDragStart() {
      if (!this.regionEditando) return;
      this.moveableDragging = true;
      this.moveableStartFrame = { ...this.moveableFrame };
    },
    onMoveableResizeStart(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      this.moveableStartFrame = { ...this.moveableFrame };

      if (e.setOrigin) {
        e.setOrigin(["50%", "50%"]);
      }

      if (e.dragStart) {
        e.dragStart.set([0, 0]);
      }
    },

    onMoveableDrag(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      const left = typeof e.left === "number"
        ? e.left
        : (this.moveableStartFrame?.left || 0) + (e.beforeTranslate?.[0] || 0);

      const top = typeof e.top === "number"
        ? e.top
        : (this.moveableStartFrame?.top || 0) + (e.beforeTranslate?.[1] || 0);

      this.moveableFrame.left = left;
      this.moveableFrame.top = top;

      this.applyMoveableFrameToTarget();
    },


    async onMoveableDragEnd() {
      if (!this.regionEditando) return;
      this.moveableDragging = false;
      await this.commitMoveableChanges();
    },
    onRegionClick(region) {
      if (this.modo === 2) {
        this.seleccionarRegionParaEditar(region);
        return;
      }

      this.handleRegionClick(region);
    },
    onMoveableResize(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      const width = Math.max(10, e.width);
      const height = Math.max(10, e.height);

      const [tx, ty] = e.drag?.beforeTranslate || [0, 0];

      this.moveableFrame.left = (this.moveableStartFrame?.left || 0) + tx;
      this.moveableFrame.top = (this.moveableStartFrame?.top || 0) + ty;
      this.moveableFrame.width = width;
      this.moveableFrame.height = height;

      this.applyMoveableFrameToTarget();
    },

    async onMoveableResizeEnd() {
      if (!this.regionEditando) return;
      await this.commitMoveableChanges();
    },
    getRegionBoxStyle(region) {
      return {
        position: "absolute",
        left: `${this.pxFromPct(region.x, "w") + this.offsetX}px`,
        top: `${this.pxFromPct(region.y, "h") + this.offsetY}px`,
        width: `${this.pxFromPct(region.w, "w")}px`,
        height: `${this.pxFromPct(region.h, "h")}px`,
        overflow: "visible",
        transform: `rotate(${Number(region.rotation || 0)}deg)`,
        transformOrigin: "50% 50%",
      };
    },


    iniciarCreacionArmarioRaiz() {
      this.creandoArmarioRaiz = true;
      this.nuevoArmario = "";
    },

    async crearArmarioRaiz() {
      if (!this.nuevoArmario.trim()) return;

      const newNode = {
        name: this.nuevoArmario,
        parent_id: null,
        x: 50,
        y: 250,
        expanded: true,
        children: [],
        id_cliente: this.idCliente,
        id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
      };

      try {
        await axios.post(`/api/nodejs/armarios`, newNode);
        this.nuevoArmario = "";
        this.$emit("fetch");
      } catch (error) {
        console.error("Error al crear armario:", error);
      }
    },

    // ---- IMAGEN / OFFSETS ----
    // cargarImagenDimensiones(src) {
    //   const img = new Image();
    //   img.onload = () => {
    //     this.imagenAncho = img.width;
    //     this.imagenAlto = img.height;

    //     this.$nextTick(() => {
    //       this.calcularOffsets();
    //       this.containerReady = true;

    //       // Importantísimo: si las regiones ya estaban cargadas antes de que termine la imagen
    //       // recalculamos offsets de nuevo para que se posicionen bien
    //       this.$nextTick(() => this.calcularOffsets());
    //     });
    //   };
    //   img.onerror = () => {
    //     this.containerReady = false;
    //     console.error("Error cargando la imagen:", src);
    //   };
    //   img.src = src;
    // },

    cargarImagenDimensiones(src) {
      this.containerReady = false; // Resetear siempre al cambiar de plano
      const img = new Image();

      img.onload = () => {
        this.imagenAncho = img.width;
        this.imagenAlto = img.height;
        
        this.$nextTick(() => {
          this.calcularOffsets();
          this.containerReady = true; // <--- Ahora sí entrará aquí
        });
      };

      img.onerror = () => {
        console.error("Error al cargar la ruta:", src);
        this.containerReady = false;
      };

      img.src = src;

      // SOLUCIÓN PARA CACHÉ: Si la imagen ya cargó, forzamos el disparo manual
      if (img.complete) {
        img.onload();
      }
    },
    calcularOffsets() {
      const contenedor = this.$refs.planoContainer;
      if (!contenedor || !this.imagenAncho || !this.imagenAlto) return;

      const contenedorWidth = contenedor.clientWidth;
      const contenedorHeight = contenedor.clientHeight;

      if (!contenedorWidth || !contenedorHeight) return;

      const imgRatio = this.imagenAncho / this.imagenAlto;
      const contRatio = contenedorWidth / contenedorHeight;

      if (imgRatio > contRatio) {
        this.anchoImagen = contenedorWidth;
        this.altoImagen = contenedorWidth / imgRatio;
        this.offsetX = 0;
        this.offsetY = (contenedorHeight - this.altoImagen) / 2;
        this.backgroundSize = `${contenedorWidth}px auto`;
        this.backgroundPosition = `center ${this.offsetY}px`;
      } else {
        this.anchoImagen = contenedorHeight * imgRatio;
        this.altoImagen = contenedorHeight;
        this.offsetX = (contenedorWidth - this.anchoImagen) / 2;
        this.offsetY = 0;
        this.backgroundSize = `auto ${contenedorHeight}px`;
        this.backgroundPosition = `${this.offsetX}px center`;
      }
    },

    // FIX: convierte a Number y valida
    pxFromPct(value, type) {
      const num = Number(value);
      if (!Number.isFinite(num)) return 10;

      const size = type === "w" ? this.anchoImagen : this.altoImagen;
      if (!size || size <= 0) return 10;

      const px = Math.round((num / 100) * size);
      return Math.max(10, px);
    },

    // ---- REGIONES ----
    agregarRegion(e) {
      const contenedor = this.$refs.planoContainer;
      if (!contenedor || !this.containerReady) return;

      const rect = contenedor.getBoundingClientRect();
      let xRel = e.clientX - rect.left - this.offsetX;
      let yRel = e.clientY - rect.top - this.offsetY;

      xRel = Math.min(Math.max(0, xRel), this.anchoImagen);
      yRel = Math.min(Math.max(0, yRel), this.altoImagen);

      const wPx = 120;
      const hPx = 80;

      const esPlano = !!this.planoSeleccionadoParaRegion;

      const nuevaRegion = {
        id: Date.now(),
        x: (xRel / this.anchoImagen) * 100,
        y: (yRel / this.altoImagen) * 100,
        w: (wPx / this.anchoImagen) * 100,
        h: (hPx / this.altoImagen) * 100,
        rotation: 0,


        id_armario: esPlano ? null : this.armarioSeleccionadoParaRegion?.id || null,
        id_plano_hijo: esPlano ? this.planoSeleccionadoParaRegion?.id || null : null,

        tipo_region: esPlano ? "plano" : "armario",
      };

      if (esPlano){
        this.regionesPlano.push(nuevaRegion)
      }
      else{
        this.regiones.push(nuevaRegion);
      }

      this.modoCrear = false;
      this.armarioSeleccionadoParaRegion = null;
      this.planoSeleccionadoParaRegion = null;
      this.guardarRegion(nuevaRegion);
      this.setRegionNueva(null); // <--- Limpiar la región nueva después de crearla
      this.$nextTick(() => this.modo=2);
    },

    async guardarRegion(region) {
      if (!this.selectedPlano?.id || !region) return;

      try {
        const esNueva = !region.id || String(region.id).length >= 13; // Date.now() temporal

        if (esNueva) {
          if (region.tipo_region === "armario") {
            await axios.put(
              `/api/nodejs/planos/armario/${region.id_armario}`,
              {
                id_plano: this.selectedPlano.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          } else if (region.tipo_region === "plano") {
            await axios.put(
              `/api/nodejs/planos/plano/${region.id_plano_hijo}`,
              {
                id_plano: this.selectedPlano.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          }
        } else {
          if (region.tipo_region === "armario") {
            await axios.put(
              `/api/nodejs/planos/mod/region`,
              {
                id_armario: region.id_armario || region.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          } else if (region.tipo_region === "plano") {
            await axios.put(
              `/api/nodejs/planos/mod/region-plano`,
              {
                id_plano: region.id_plano_hijo || region.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          }
        }

        await this.cargarRegionesDesdeAPI();

        this.snackbarText = "Cambios guardados";
        this.snackbar = true;
      } catch (error) {
        console.error("Error al guardar regiones:", error);
        this.snackbarText = "Error al guardar";
        this.snackbar = true;
      }
    },

    async eliminarRegion(region) {
      const esPlano = region.tipo_region === "plano";

      if (
        !confirm(
          `¿Estás seguro de que deseas eliminar la región vinculada a "${
            region.nombre || (esPlano ? "este subplano" : "este armario")
          }"?`
        )
      ) {
        return;
      }

      try {
        if (esPlano) {
          await axios.put(
            `/api/nodejs/planos/mod/region-plano`,
            {
              id_plano: region.id_plano_hijo || region.id,
              pos_x: null,
              pos_y: null,
              ancho: null,
              alto: null,
            }
          );
        } else {
          await axios.put(
            `/api/nodejs/planos/mod/region`,
            {
              id_armario: region.id_armario || region.id,
              pos_x: null,
              pos_y: null,
              ancho: null,
              alto: null,
            }
          );
        }

        await this.cargarRegionesDesdeAPI();

        this.snackbarText = "Región eliminada correctamente";
        this.snackbar = true;
        this.$emit("fetch");
      } catch (error) {
        console.error("Error al eliminar la región:", error);
        this.snackbarText = "No se pudo eliminar la región";
        this.snackbar = true;
      }
    },

    // ---- REGION ----
    handleRegionClick(region) {
      const destino = this.getRegionDestino(region);


      if (destino.tipo === "plano") {
        this.$emit("ir-a-subplano", {
          id: destino.id,
          region,
        });
        return;
      }

      if (destino.tipo === "armario") {
        axios
          .get(`/api/nodejs/armarios/${destino.id}/adjuntos`)
          .then((response) => {
            this.clickedRegion = region;
            this.adjuntos = response.data.adjuntos;
            this.dialogAdjuntos = true;

            this.adjuntos.forEach((adjunto) => {
              adjunto.usuario = this.usuarios.find((u) => u.id === adjunto.id_usuario) || {
                username: "Desconocido",
              };
            });
          })
          .catch((error) => {
            console.error("Error al obtener archivos adjuntos:", error);
          });

        return;
      }

      console.warn("La región no tiene destino válido", region);
    },

    closeAdjuntos() {
      this.adjuntos = [];
      this.clickedRegion = null;
      this.dialogAdjuntos = false;
    },

    normalizarRegion(region) {
      return {
        ...region,
        x: parseFloat(region.x ?? region.pos_x ?? 0),
        y: parseFloat(region.y ?? region.pos_y ?? 0),
        w: parseFloat(region.w ?? region.ancho ?? 0),
        h: parseFloat(region.h ?? region.alto ?? 0),
        rotation: parseFloat(region.rotation ?? 0),
        tipo_region: region.tipo_region || "armario",
      };
    },
    getRegionKey(region) {
      return `${region.tipo_region}-${region.id}`;
    },

    getRegionDestino(region) {
      const destino = region.tipo_region === "plano"
        ? {
            tipo: "plano",
            id: region.id,
          }
        : {
            tipo: "armario",
            id: region.id_armario || region.id,
          };

      return destino;
    },
    seleccionarRegionParaEditar(region) {
      if (this.modo !== 2) return;

      this.regionEditando = region;
      this.moveableDragging = false;

      const box = this.getRegionPxBox(region);
      this.moveableFrame = { ...box };
      this.moveableStartFrame = null;

      this.$nextTick(() => {
        const refName = `region-${this.getRegionKey(region)}`;
        const ref = this.$refs[refName];
        const rawRef = Array.isArray(ref) ? ref[0] : ref;
        const el = rawRef?.$el || rawRef;

        this.moveableTarget = el || null;

        if (this.moveableTarget) {
          this.applyMoveableFrameToTarget();
          this.$refs.moveable?.updateRect?.();
        }
      });
    },
    finalizarEdicion() {
      this.modo = 1;
      this.regionEditando = null;
      this.moveableTarget = null;
      this.moveableDragging = false;
      this.moveableStartFrame = null;
      this.estaRotando = false;
      this.moveableFrame = {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        rotate: 0,
      };
    },
    seleccionarPlanoParaRegion(plano) {
      this.planoSeleccionadoParaRegion = plano;
      this.armarioSeleccionadoParaRegion = null;
      this.modoCrear = true;
      this.dialogSeleccionarArmario = false;
      this.snackbarText = `Subplano "${plano.nombre}" seleccionado. Haz clic en el plano para crear la región.`;
      this.snackbar = true;
    },

    // ---- SUBNODO DESDE PLANOS (lo dejo igual salvo que había un this.tiposSubnodo que no existe) ----
    async crearSubnodo(payload) {
      try {
        const { nombre, tipoSeleccionado, tipoNuevoTexto, tipoNuevoBanner } = payload;
        if (!nombre.trim()) {
          alert("Debes poner un nombre para el subnodo");
          return;
        }

        let tipoFinal = tipoSeleccionado;

        if (!tipoFinal && tipoNuevoTexto && tipoNuevoTexto.trim()) {
          try {
            if (tipoNuevoBanner) {
              const formData = new FormData();
              formData.append("name", tipoNuevoTexto.trim());
              formData.append("banner", tipoNuevoBanner);

              const res = await axios.post(
                `/api/nodejs/armarios/tipos`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
              );

              tipoFinal = res.data.id;

              // OJO: en tu código original usabas this.tiposSubnodo, pero NO existe en data()
              // Si quieres añadir el tipo a la lista, lo correcto sería:
              this.tiposNodo.push({
                id: tipoFinal,
                name: tipoNuevoTexto.trim(),
                id_cliente: this.idCliente,
                id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
                banner_url: res.data.banner_url,
              });
            } else {
              alert("Debes subir un banner para crear un nuevo tipo");
              return;
            }
          } catch (err) {
            alert("No se pudo crear el tipo nuevo");
            console.error(err);
            return;
          }
        }

        if (!tipoFinal) {
          alert("Debes seleccionar o crear un tipo");
          return;
        }

        const payloadSubnodo = {
          name: nombre,
          id_parent: this.subnodoForm.parent_id,
          id_tipo: tipoFinal,
          x: null,
          y: null,
          id_cliente: this.idCliente,
          id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
          tipo: tipoFinal,
          expanded: true,
        };

        const res = await axios.post(
          `/api/nodejs/armarios`,
          payloadSubnodo
        );

        const armario = { id: res.data.id, name: nombre };
        this.seleccionarArmarioParaRegion(armario);

        this.dialogCrearSubNodo = false;
        this.$emit("fetch");
      } catch (e) {
        console.error("Error al crear Subnodo y región: ", e);
      }
    },
  },
};
</script>

<style scoped>
.plano-workspace {
  background-color: #f0f2f5 !important;
  position: relative;
  overflow: hidden;
}

.action-hud {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2; 
  background-color: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(5px);
  max-width: fit-content;
  margin-left: auto !important;
  margin-right: auto !important;
}

.plano-viewport {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  padding: 20px;
  z-index: 1; 
}

.plano-canvas {
  background-color: white;
  border-radius: 8px;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 80vh;
}

/* REGIONES */
.region-box {
  box-sizing: border-box;
  transition: box-shadow 0.3s ease;
  z-index: 2; /* FIX: asegura que se vean por encima */
  overflow: visible !important;
}

.region-view,
.region-edit {
  border-radius: 4px;
}

.region-view {
  cursor: pointer;
}

.region-edit {
  cursor: move;
}

.region-visual {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  transition: transform 0.05s linear;
  border-radius: 4px;
}

/* ARMARIOS */
.region-view.region-armario .region-visual {
  border: 2px solid #1976d2;
  background-color: rgba(25, 118, 210, 0.15);
}

.region-view.region-armario:hover .region-visual {
  background-color: rgba(25, 118, 210, 0.3);
  box-shadow: 0 0 10px rgba(25, 118, 210, 0.5);
}

.region-edit.region-armario .region-visual {
  border: 2px dashed #fb8c00;
  background-color: rgba(251, 140, 0, 0.2);
}

.region-view.region-plano .region-visual {
  border: 2px solid #7e57c2;
  background-color: rgba(126, 87, 194, 0.16);
}

.region-view.region-plano:hover .region-visual {
  background-color: rgba(126, 87, 194, 0.28);
  box-shadow: 0 0 10px rgba(126, 87, 194, 0.45);
}

.region-edit.region-plano .region-visual {
  border: 2px dashed #7e57c2;
  background-color: rgba(126, 87, 194, 0.20);
}

/* ETIQUETA */
.region-label {
  position: absolute;
  top: -20px;
  left: 0;
  font-size: 10px;
  color: white;
  padding: 0 4px;
  border-radius: 2px;
  white-space: nowrap;
}

.region-armario .region-label {
  background: #fb8c00;
}

.region-plano .region-label {
  background: #7e57c2;
}

.region-pulse {
  animation: pulse-halo 1s ease-in-out infinite;
}
.region-selected {
  outline: 2px solid #00bcd4;
  outline-offset: 3px;
}

/* más potente: halo + glow */
@keyframes pulse-halo {
  0% {
    box-shadow: 0 0 0 0 rgba(25,118,210,.0), 0 0 0 0 rgba(25,118,210,.0);
  }
  40% {
    box-shadow: 0 0 0 10px rgba(25,118,210,.45), 0 0 18px 6px rgba(25,118,210,.45);
  }
  100% {
    box-shadow: 0 0 0 18px rgba(25,118,210,.0), 0 0 0 0 rgba(25,118,210,.0);
  }
}

.hierarchy-line {
  width: 15px;
  height: 1px;
  background-color: #e0e0e0;
  margin-right: 5px;
}

.border-bottom {
  border-bottom: 1px solid #f0f0f0;
}

.delete-region-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 20;
  background-color: white !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>